module.exports = __webpack_public_path__ + "static/media/BNP_Kalkulator.750ac0f2.jpg";